import { render, staticRenderFns } from "./CustomerOtherPart.vue?vue&type=template&id=945ab294&scoped=true"
import script from "./CustomerOtherPart.vue?vue&type=script&lang=ts"
export * from "./CustomerOtherPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945ab294",
  null
  
)

export default component.exports